export default __webpack_public_path__ + "static/media/cat.f81ee7d1.svg";